module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "founder"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Meet Our Founder")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.bio)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/retta.jpg")
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Founder & CEO")]), _vm._v(" "), _c('p', [_vm._v("Retta Jitner"), _c('br'), _vm._v("\n        Pencils for Kids, Inc.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cea1e83e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/Founder.vue
// module id = 334
// module chunks = 1